<template>
  <a-card :bordered="false">

    <!-- 上部订单查询 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24" style="float:left">
            <a-form-item label="客户名称">
              <a-select showSearch :defaultValue="defaultBusinessId" v-model="queryParam.businessId" style="max-width: 320px" :filterOption="filterOption" placeholder="请选择" default-value="">
                <a-select-option value=''>请选择</a-select-option>
                <a-select-option v-for="(item, index) in businessSelect" :key="index" :value="item.id">{{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="10" :sm="24">
            <a-form-item label="查询日期">
              <a-date-picker
                format="YYYY-MM-DD"
                v-model="queryParam.startDate"
                placeholder=""
                :disabledDate="disabledDate"
              />
              至
              <a-date-picker
                format="YYYY-MM-DD"
                v-model="queryParam.endDate"
                placeholder=""
                :disabledDate="disabledDate"
              />
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="24" style="float:left">
            <a-form-item label="截止余额">
              <a-select  v-model="queryParam.queryType" style="max-width: 320px" :filterOption="filterOption" placeholder="请选择" default-value="">
                <a-select-option value=''>不查询</a-select-option>
                <a-select-option value='endMoney'>查询</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>


          <a-col :md="8" :sm="24" style="float:left">
            <a-form-item label="类型">
              <a-select  v-model="queryParam.receiptType" style="max-width: 320px" :filterOption="filterOption" placeholder="请选择" default-value="">
                <a-select-option value=''>不查询</a-select-option>
                <a-select-option value='收款'>收款</a-select-option>
                <a-select-option value='授信'>授信</a-select-option>
                <a-select-option value='消费'>消费</a-select-option>
                <a-select-option value='反充值'>反充值</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24" style="float:right">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh()">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <a-button style="margin-left: 0px" type="primary" @click="handlexsExport()">导出</a-button>

    <div class="table-operator">
      <span style="margin-left: 40px;font-size:16px;color:red">收款金额合计：</span><span>{{ totalAmount | formatCurrency}}</span>
    </div>

    <s-table ref="table" size="small" :bordered="config.globlaBordered" :rowKey="(record) => record.id"
      :columns="columns" :data="loadData" :scroll="{ x: 3000}"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}">

<!--       <template slot="footer" slot-scope="currentPageData">
        <span></span><span style="margin-left:540px; font-size:16px;font-weight: 500;">合计：{{ totalAmount | formatCurrency}}</span>
      </template>
   -->
     <span slot="action" slot-scope="text, record">

         <a @click="handleInvalid(record)"
            v-if="record.status == '0' && rolelimit == true"
        >审核</a>
      </span>
    </s-table>

  <a-modal title="审核设置" style="top: 100px;" :width="300" v-model="checkvisible" @ok="handleOk">
      <a-form :form="form">
        <a-radio-group @change="onRadioChange" v-model="checkvalue">
          <a-radio :value="1">通过</a-radio>
          <a-radio :value="2">拒绝</a-radio>
        </a-radio-group>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import { STable } from '@/components'
  import { corpBusinessList,updateaccount} from '@/api/basic'
  import { receiptPage } from '@/api/order'
  import moment from 'moment'
  import { formatDate } from '../../utils/date.js'
  import { formatCurrency } from '@/utils/util'
  import config from '@/config/defaultSettings'
   import { findPrivileBycode } from '@/api/sys'
  import Vue from "vue";
  export default {
    name: 'ReceiptDetails',
    components: {
      STable
    },
    data() {
      return {
        pageSizeOptionsList: ['10'],
        businessSelect: [],
        description:'收款明细',
        rolelimit : false,
         roleId:null,
        defaultBusinessId:null,

        // 查询参数
        queryParam: {startDate:moment().startOf('month'), endDate:moment(new Date(), 'YYYY-MM-DD')},
        totalAmount:0,
        footerDataSource:[],  //    :footer="handleFooterShow"
        checkvisible: false,
        checkvalue: 1,
        businessId: null,
        receiptAmount: null,
        receiptType: null,
        id: null,
         form: this.$form.createForm(this),
        // 表头
        columns: [

          {
            title: '客户名称',
            dataIndex: 'businessName',
            fixed: 'left',
              width: '300px'
          },
          {
            title: '类型',
            dataIndex: 'receiptType',
            width: '50px'
          },
           {
            title: '收款单号',
            dataIndex: 'receiptNo',
            width: '150px'
          },
          {
            title: '收款日期',
            dataIndex: 'receiptTime',
            width: '100px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd')
              }
            }
          },
          {
            title: '收款金额',
            dataIndex: 'receiptAmount',
            width: '100px',
            customRender: (text, record) => {
              return formatCurrency(text)
            }
          },
           {
            title: '收款明细',
            dataIndex: 'receiptDetails',
            width: '600px',
          },
          {
            title: '备注',
            dataIndex: 'memo',
            width: '100px',
          },
          {
            title: '制单人',
            dataIndex: 'createId',
            width: '80px',
            customRender: (text, row, index) => {
              if (!text) return "";
              let userList = this.$store.getters.userList;
              return userList[text];
            }
          },
          {
            title: '制单时间',
            dataIndex: 'createTime',
            width: '160px',
            customRender: text => {
              if (text) {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
              }
            }
          },
           {
            title: '称重单号',
            dataIndex: 'weighingNo',
            width: '200px',
          },

          {
            title: '',



          },
          {
            title: '操作',
            width: '150px',
            dataIndex: 'action',
            fixed: 'right',
            scopedSlots: { customRender: 'action' }
          }
        ],

        // 合计

        columnv: [
          {
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: '10%'
          },
          {
            title: '门店',
            dataIndex: 'branchname',
            key: 'branchname',
            width: '10%',
            render: (text, record) => <span>合计</span>
          },
          {
            title: '数量',
            dataIndex: 'num',
            key: 'num',
            width: '80%',
            render: (text, record) => <span>{`-`}</span>
          },
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          if (this.queryParam.startDate > this.queryParam.endDate){
            this.$message.warning('开始日期不能大于结束日期',3)
            return
          }
          let condition = Object.assign(parameter, this.queryParam)
          if (condition.startDate){
            condition.startDate = formatDate(new Date(condition.startDate), 'yyyy-MM-dd')

          }
          if (condition.endDate){
            condition.endDate = formatDate(new Date(condition.endDate), 'yyyy-MM-dd')
          }
          return receiptPage(condition).then(res => {
     /*        if (res.data.content && res.data.content.length > 0){
              this.footerDataSource.push(res.data.content[0])
            } */
            this.totalAmount = res.data.totalAmount
            return res.data
          })
        },
        loadSelect() {
          new Promise(resolve => {
              const data = corpBusinessList({}).then(res => {
                return res.data
              })
              resolve(data)
            }).then(res => {
              this.businessSelect = res
          })
        },
      }
    },
    created() {
       this.checkButtonPrivilege()
       this.roleId = this.$store.getters.roles
      this.loadSelect()
      // 初始化查询条件
      this.queryParam = this.queryParam || null
      if (this.$route.query.businessId){
        this.defaultBusinessId = parseInt(this.$route.query.businessId)
        this.queryParam.businessId = parseInt(this.$route.query.businessId)
      }
    },

    filters: {
      formatCurrency (amount) {
        return formatCurrency(amount)
      }
    },
    methods: {

      handlexsExport() {
        const token = Vue.ls.get(ACCESS_TOKEN)
        console.log("ACCESS_TOKEN:" + ACCESS_TOKEN + "/" + token)
        window.location.href =
          this.config.downloadreceiptUrl +
          '&accessToken=' +
          token+
          '&startDate=' +
          formatDate(new Date(this.queryParam.startDate), 'yyyy-MM-dd')+
          '&endDate='+
          formatDate(new Date(this.queryParam.endDate), 'yyyy-MM-dd')+
          '&businessId='+
          this.queryParam.businessId+
          '&receiptType='+
          this.queryParam.receiptType+
          '&queryType='+
          this.queryParam.queryType

      },

       //分配物流记录按钮权限
     checkButtonPrivilege(record) {

         new Promise(resolve => {
          const data = findPrivileBycode({ code:'czje-handler' }).then(res => { return res.data })
          resolve(data)
        }).then(res => {

          if(res=='czje-handler'){
            this.rolelimit=true
          }
        })

      },
      moment,

      disabledDate(current) {
        return current && current > moment().endOf('day')
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
        handleInvalid(record) {
          this.checkvisible= true
           this.businessId = record.businessId
            this.receiptAmount = record.receiptAmount
             this.receiptType = record.receiptType
            this.id=record.id
      },
      handleOk() {
          updateaccount(Object.assign({}, { id: this.id,businessId: this.businessId,receiptType: this.receiptType, receiptAmount: this.receiptAmount, status: this.checkvalue }))
        .then(res => {
          if (res.code === '0') {
            this.$refs.table.refresh()
          }
        })
        .catch(() => {})
        .finally(() => {
          this.checkvisible = false
        })
      },
       onRadioChange(e) {
       console.log('radio checked', e.target.value)
    },
      handleFooterShow(data) {
        return (
          <a-table
            rowKey={Math.random}
            bordered={false}
            pagination={false}
            columns={this.columnv}
            dataSource={this.footerDataSource}
            showHeader={false}
            size="small"
          ></a-table>
      );
    },

    },
    watch: {}
  }
</script>

<style scoped>
  /deep/ .ant-form-item {
    margin-bottom: 10px;
  }
</style>